import axios from 'axios'
import {
  CspLoginRequest,
  CspLoginResponse,
  CspMeResponse,
} from 'src/queries/csp/issuers/issuers.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

/**
 * `GET /csp/me` — the CSP user plus the issuers the CSP user can act for.
 *
 * Auth parity: the legacy `getCspMe` thunk uses
 * `selectCspAuthedJsonApiRequestConfig` (CSP JWT, not the regular user JWT),
 * mapped to `RequestConfig.Csp` in the shared request-config boundary.
 */
export const getCspMe = async (): Promise<CspMeResponse> => {
  return getResponseData(
    axios.get<CspMeResponse>('/csp/me', getRequestConfig(RequestConfig.Csp)),
  )
}

/**
 * `POST /csp/login` — authenticates a CSP user and returns tokens plus the
 * same embedded issuer list as `GET /csp/me`.
 *
 * Auth parity: both legacy thunks against this endpoint (`postCspLogin`,
 * `postCspLoginIssuerInfo`) use `selectUnauthedJsonApiRequestConfig`, so this
 * uses `RequestConfig.Unauthed`.
 */
export const postCspLogin = async (
  request: CspLoginRequest,
): Promise<CspLoginResponse> => {
  return getResponseData(
    axios.post<CspLoginResponse>(
      '/csp/login',
      request,
      getRequestConfig(RequestConfig.Unauthed),
    ),
  )
}
